<div class="rootContainer">

    <!--Ввод старого пароля-->
    <div class="cardContainer"
         *ngIf="currentStep === ChangePasswordStepType.EnterOldPassword"
         [style.display]="currentStep === ChangePasswordStepType.EnterOldPassword ? 'block' : 'none'">

        <h2>
            {{ 'Pages.ChangePassword.EnterOldPasswordHeaderText' | translate }}
        </h2>

        <app-enter-old-password #enterOldPasswordComponent
                                submitButtonText="{{ 'Pages.ChangePassword.EnterOldPasswordSubmitButtonText' | translate }}"
                                (submited)="changePassword_IsPasswordValid($event)">
        </app-enter-old-password>

    </div>


    <!--Ввод номера телефона и отправка СМС кода-->
    <div class="cardContainer"
         *ngIf="currentStep === ChangePasswordStepType.SendSMSCode"
         [style.display]="currentStep === ChangePasswordStepType.SendSMSCode ? 'block' : 'none'">

        <h2>
            {{ 'Pages.ChangePassword.EnterPhoneHeaderText' | translate }}
        </h2>

        <app-enter-phone #enterPhoneComponent
                         submitButtonText="{{ 'Pages.ChangePassword.EnterPhoneSubmitButtonText' | translate }}"
                         [(phoneValueWithRegion)]="phoneValueWithRegion"
                         (submited)="changePassword_SendSMSCode($event)">
        </app-enter-phone>
    </div>


    <!--Ввод и подтверждение СМС кода-->
    <div class="cardContainer"
         [style.display]="currentStep === ChangePasswordStepType.EnterSMSCode ? 'block' : 'none'">

        <h2>
            {{ 'Pages.ChangePassword.EnterSMSCodeHeaderText' | translate }}
        </h2>

        <app-enter-sms-code #enterSMSCodeComponent
                            submitButtonText="{{ 'Pages.ChangePassword.EnterSMSCodeSubmitButtonText' | translate }}"
                            [(phoneValueWithRegion)]="phoneValueWithRegion"
                            (resendSMSCode)="changePassword_SendSMSCode($event)"
                            (submited)="changePassword_ConfirmSMSCode($event)">
        </app-enter-sms-code>

        <div class="text-muted">
            <span>
                {{ 'Pages.ChangePassword.ConfirmCodeHelpText' | translate }}
            </span>
        </div>
    </div>


    <!--Установка нового пароля-->
    <div class="cardContainer"
         [style.display]="currentStep === ChangePasswordStepType.EnterNewPassword ? 'block' : 'none'">

        <h2>
            {{ 'Pages.ChangePassword.EnterNewPasswordHeaderText' | translate }}
        </h2>

        <app-enter-new-password #enterNewPasswordComponent
                                submitButtonText="{{ 'Pages.ChangePassword.EnterSMSCodeSubmitButtonText' | translate }}"
                                (submited)="changePassword_SetPassword($event)">
        </app-enter-new-password>
    </div>


</div>
